// import React, { useCallback, useEffect, useState } from "react";
// import ProcessLayout from "../Common/ProcessLayout";
// import PostProcessingFilesToProcess from "./PostProcessingComponents/PostProcessingFilesToProcess";
// import PostProcessingProcess from "./PostProcessingComponents/PostProcessingProcess";
// import PostProcessingProcessLogs from "./PostProcessingComponents/PostProcessingProcessLogs";
// import PostProcessingFilewiseStatusLogs from "./PostProcessingComponents/PostProcessingFilewiseStatusLogs";
// import axios from "axios";
// import Popup from "../Common/Popup";
// import { handleApiError } from "../Common/APIUtils";

// const POSTPROCESSING_URL = process.env.REACT_APP_POSTPROCESSING_URL || "http://localhost:8010";

// function PostProcessing() {
//     const [startProcess, setStartProcess] = useState(false);
//     const [fetchedFilesData, setFetchedFilesData] = useState([]);
//     const [inProgressFiles, setInProgressFiles] = useState([]);
//     const [logsData, setLogsData] = useState([]);
//     const [processedFiles, setProcessedFiles] = useState([]);
//     const [unprocessedFiles, setUnProcessedFiles] = useState([]);
//     const [Loader, setLoader] = useState(true);
//     const [startIndex, setStartIndex] = useState(undefined);
//     const [endIndex, setEndIndex] = useState(undefined);
//     const [rowSelection, setRowSelection] = useState({});
//     const [fslstartIndex, setfslStartIndex] = useState(undefined);
//     const [fslendIndex, setfslEndIndex] = useState(undefined);
//     const [fslrowSelection, setfslRowSelection] = useState({});
    
//     const [postProcessingSettings, setPostProcessingSettings] = useState({
//         api_key: "",
//         text_type: "default"
//     });
    
//     let [isOpenPopup, setIsOpenPopup] = useState(false);
//     let [msg, setMsg] = useState(false);
//     let [isSuccess, setIsSuccess] = useState(false);

//     function closePopup() {
//         setIsOpenPopup(false);
//     }

//     const openPopup = useCallback(() => {
//         setIsOpenPopup(true);
//     }, []);

//     const fetchInProgressFiles = useCallback(async () => {
//         try {
//             const projectCode = sessionStorage.getItem("projectCode");
//             if (!projectCode) return;

//             const response = await axios.get(
//                 `${POSTPROCESSING_URL}/post-processing/in-progress/${projectCode}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//                     },
//                 }
//             );

//             if (response.data && response.data.data) {
//                 setInProgressFiles(response.data.data);
//             }
//         } catch (error) {
//             console.log("No in-progress files:", error.message);
//             setInProgressFiles([]);
//         }
//     }, []);

//     useEffect(() => {
//         fetchInProgressFiles();
//         const interval = setInterval(fetchInProgressFiles, 5000);
//         return () => clearInterval(interval);
//     }, [fetchInProgressFiles]);

//     const fetchAllFiles = useCallback(async (batch_no = null) => {
//         try {
//             setLoader(true);
//             const projectCode = sessionStorage.getItem("projectCode");
            
//             const response = await axios.get(
//                 `${POSTPROCESSING_URL}/post-processing/getfilelist/${projectCode}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//                     },
//                     params: {
//                         batch: batch_no || sessionStorage.getItem("batch") || null,
//                     },
//                 }
//             );

//             if (response.data && response.data.data) {
//                 const allFiles = response.data.data;
//                 // const availableFiles = allFiles.filter(file => 
//                 //     file.status !== "Inprogress" && 
//                 //     file.status !== "submitted" &&
//                 //     file.status !== "Processing" &&
//                 //     file.status !== "Success" &&
//                 //     file.status !== "success"
//                 // );
//                 // Filter: only txt/json files, exclude processing/completed files
//                 const availableFiles = allFiles.filter(file => {
//                     const fileName = file.file_name || file.name || "";
//                     const isAllowedFile = fileName.endsWith('.txt') || fileName.endsWith('.json');
//                     const isProcessing = file.status === "Inprogress" || file.status === "submitted" || file.status === "Processing" || file.status === "Success" || file.status === "success";
                    
//                     return isAllowedFile && !isProcessing;
//                 });
//                 setFetchedFilesData(availableFiles);
//             }
//         } catch (error) {
//             const errorMessage = handleApiError(error);
//             setMsg(errorMessage);
//             setIsSuccess(false);
//             openPopup();
//         } finally {
//             setTimeout(() => setLoader(false), 100);
//         }
//     }, [openPopup]);

//     // const handleStartProcess = async (data) => {
//     //     setStartProcess(true);
//     //     const currentLogs = [];
//     //     const updatedProcessedFiles = [];
//     //     const updatedUnprocessedFiles = [];

//     //     const formattedStartDateTime = () => {
//     //         const date = new Date();
//     //         const formattedDateString = date
//     //             .toLocaleString("en-US", {
//     //                 day: "2-digit",
//     //                 month: "2-digit",
//     //                 year: "numeric",
//     //                 hour: "2-digit",
//     //                 minute: "2-digit",
//     //                 second: "2-digit",
//     //                 hour12: false,
//     //             })
//     //             .replace(/\//g, "/")
//     //             .replace(",", " ");
//     //         const [month, day, yearAndTime] = formattedDateString.split("/");
//     //         return `${day}-${month}-${yearAndTime}`;
//     //     };

//     //     for (let i = 0; i < data.length; i++) {
//     //         let startdt = formattedStartDateTime();
//     //         let file = data[i];
            
//     //         try {
//     //             if (!file.file_code) {
//     //                 throw new Error("File code is missing");
//     //             }

//     //             const payload = {
//     //                 payload: {
//     //                     project_code: sessionStorage.getItem("projectCode"),
//     //                     file_code: file.file_code,
//     //                     api_key: postProcessingSettings.api_key,
//     //                     text_type: postProcessingSettings.text_type
//     //                 }
//     //             };

//     //             const response = await axios.post(
//     //                 `${POSTPROCESSING_URL}/post-processing/`,
//     //                 payload,
//     //                 {
//     //                     headers: {
//     //                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//     //                         "Content-Type": "application/json"
//     //                     },
//     //                 }
//     //             );

//     //             if (response.data.status === "submitted") {
//     //                 const submittedFile = {
//     //                     ...file,
//     //                     file_code: file.file_code,
//     //                     status: "submitted",
//     //                     response: {
//     //                         message: response.data.message,
//     //                         submitted_at: new Date().toISOString()
//     //                     },
//     //                     start_date_time: startdt,
//     //                     last_modified: "",
//     //                     text_type: postProcessingSettings.text_type
//     //                 };
                    
//     //                 currentLogs.push({
//     //                     creation_date: new Date(),
//     //                     filename: file.name,
//     //                     status: "submitted",
//     //                     message: response.data.message
//     //                 });
                    
//     //                 updatedProcessedFiles.push(submittedFile);
//     //                 // setInProgressFiles(prev => [...prev, submittedFile]);
//     //             } else {
//     //                 console.error('Unexpected response status:', response.data.status);
//     //                 const errordate = new Date();
//     //                 currentLogs.push({
//     //                     creation_date: errordate,
//     //                     filename: file.name,
//     //                     status: "error"
//     //                 });
//     //                 updatedUnprocessedFiles.push(file);
//     //             }
//     //         } catch (error) {
//     //             console.error('Post-Processing Error:', error);
                
//     //             const errordate = new Date();
//     //             let errorMessage = error.response?.data?.detail || 
//     //                             error.response?.data?.message || 
//     //                             error.message ||
//     //                             "An error occurred during post-processing";
                
//     //             currentLogs.push({
//     //                 filename: file.name,
//     //                 creation_date: errordate,
//     //                 error: errorMessage
//     //             });
                
//     //             setMsg(errorMessage);
//     //             setIsSuccess(false);
//     //             if (data.length === 1) {
//     //                 openPopup();
//     //             }
                
//     //             updatedUnprocessedFiles.push(file);
//     //         }
//     //     }

//     //     setLogsData(currentLogs);
//     //     setProcessedFiles(updatedProcessedFiles);
//     //     setUnProcessedFiles(updatedUnprocessedFiles);
//     //     setInProgressFiles(updatedProcessedFiles);
//     //     setStartProcess(false);
//     //     await fetchAllFiles();
//     // };

//     const handleStartProcess = async (data) => {
//         setStartProcess(true);
//         const currentLogs = [];
//         const updatedProcessedFiles = [];
//         const updatedUnprocessedFiles = [];

//         const formattedStartDateTime = () => {
//             const date = new Date();
//             const formattedDateString = date
//                 .toLocaleString("en-US", {
//                     day: "2-digit",
//                     month: "2-digit",
//                     year: "numeric",
//                     hour: "2-digit",
//                     minute: "2-digit",
//                     second: "2-digit",
//                     hour12: false,
//                 })
//                 .replace(/\//g, "/")
//                 .replace(",", " ");
//             const [month, day, yearAndTime] = formattedDateString.split("/");
//             return `${day}-${month}-${yearAndTime}`;
//         };

//         for (let i = 0; i < data.length; i++) {
//             let startdt = formattedStartDateTime();
//             let file = data[i];
            
//             try {
//                 if (!file.file_code) {
//                     throw new Error("File code is missing");
//                 }

//                 const payload = {
//                     payload: {
//                         project_code: sessionStorage.getItem("projectCode"),
//                         file_code: file.file_code,
//                         api_key: postProcessingSettings.api_key,
//                         text_type: postProcessingSettings.text_type
//                     }
//                 };

//                 const response = await axios.post(
//                     `${POSTPROCESSING_URL}/post-processing/`,
//                     payload,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//                             "Content-Type": "application/json"
//                         },
//                     }
//                 );

//                 if (response.data.status === "submitted") {
//                     const submittedFile = {
//                         ...file,
//                         file_code: file.file_code,
//                         name: file.name || file.file_name,
//                         file_name: file.file_name || file.name,
//                         status: "submitted",
//                         response: {
//                             message: response.data.message,
//                             submitted_at: new Date().toISOString()
//                         },
//                         start_date_time: startdt,
//                         last_modified: "",
//                         text_type: postProcessingSettings.text_type
//                     };
                    
//                     currentLogs.push({
//                         creation_date: new Date(),
//                         filename: file.name || file.file_name,
//                         status: "submitted",
//                         message: response.data.message
//                     });
                    
//                     updatedProcessedFiles.push(submittedFile);
                    
//                     // Add to in-progress files immediately
//                     setInProgressFiles(prev => [...prev, submittedFile]);
//                 } else {
//                     console.error('Unexpected response status:', response.data.status);
//                     const errordate = new Date();
//                     currentLogs.push({
//                         creation_date: errordate,
//                         filename: file.name || file.file_name,
//                         status: "error"
//                     });
//                     updatedUnprocessedFiles.push(file);
//                 }
//             } catch (error) {
//                 console.error('Post-Processing Error:', error);
                
//                 const errordate = new Date();
//                 let errorMessage = error.response?.data?.detail || 
//                                 error.response?.data?.message || 
//                                 error.message ||
//                                 "An error occurred during post-processing";
                
//                 currentLogs.push({
//                     filename: file.name || file.file_name,
//                     creation_date: errordate,
//                     error: errorMessage
//                 });
                
//                 setMsg(errorMessage);
//                 setIsSuccess(false);
//                 if (data.length === 1) {
//                     openPopup();
//                 }
                
//                 updatedUnprocessedFiles.push(file);
//             }
//         }

//         setLogsData(currentLogs);
//         setProcessedFiles(updatedProcessedFiles);
//         setUnProcessedFiles(updatedUnprocessedFiles);
//         setStartProcess(false);
//         await fetchAllFiles();
//     };

//     const ReloadData = useCallback(async () => {
//         setRowSelection({});
//         setStartIndex(undefined);
//         setEndIndex(undefined);
//         await fetchAllFiles();
//     }, [fetchAllFiles]);

//     const fetchBatchData = async (batch_no) => {
//         await fetchAllFiles(batch_no);
//     };

//     useEffect(() => {
//         fetchAllFiles();
//     }, [fetchAllFiles]);

//     const tabs = [
//         {
//             id: 1,
//             title: "Files",
//             content: (
//                 <PostProcessingFilesToProcess
//                     ReloadData={ReloadData}
//                     items={fetchedFilesData}
//                     startProcess={startProcess}
//                     setFilesData={handleStartProcess}
//                     Loader={Loader}
//                     startIndex={startIndex}
//                     endIndex={endIndex}
//                     setStartIndex={setStartIndex}
//                     setEndIndex={setEndIndex}
//                     rowSelection={rowSelection}
//                     setRowSelection={setRowSelection}
//                     postProcessingSettings={postProcessingSettings}
//                     setPostProcessingSettings={setPostProcessingSettings}
//                 />
//             ),
//         },
//         {
//             id: 2,
//             title: "Post-Processing Process",
//             content: (
//                 <PostProcessingProcess
//                     startProcess={startProcess}
//                     selectedFilesToProcess={inProgressFiles}
//                 />
//             ),
//         },
//         {
//             id: 3,
//             title: "Logs",
//             content: (
//                 <PostProcessingProcessLogs
//                     logs={logsData}
//                     processedfiles={processedFiles}
//                     unprocessedfiles={unprocessedFiles}
//                 />
//             ),
//         },
//         {
//             id: 4,
//             title: "All Files Status",
//             content: (
//                 <PostProcessingFilewiseStatusLogs 
//                     startIndex={fslstartIndex}
//                     endIndex={fslendIndex}
//                     setStartIndex={setfslStartIndex}
//                     setEndIndex={setfslEndIndex}
//                     rowSelection={fslrowSelection}
//                     setRowSelection={setfslRowSelection}
//                 />
//             ),
//         },
//     ];

//     return (
//         <>
//             <Popup
//                 isOpen={isOpenPopup}
//                 msg={msg}
//                 closeModal={closePopup}
//                 isSuccess={isSuccess}
//             />
//             <ProcessLayout
//                 startProcess={startProcess}
//                 tabs={tabs}
//                 server="Post-Processing Service"
//                 batching={true}
//                 handleBatchChange={fetchBatchData}
//             />
//         </>
//     );
// }

// export default PostProcessing;

import React, { useCallback, useEffect, useState, useRef } from "react";
import ProcessLayout from "../Common/ProcessLayout";
import PostProcessingFilesToProcess from "./PostProcessingComponents/PostProcessingFilesToProcess";
import PostProcessingProcess from "./PostProcessingComponents/PostProcessingProcess";
import PostProcessingProcessLogs from "./PostProcessingComponents/PostProcessingProcessLogs";
import PostProcessingFilewiseStatusLogs from "./PostProcessingComponents/PostProcessingFilewiseStatusLogs";
import axios from "axios";
import Popup from "../Common/Popup";
import { handleApiError } from "../Common/APIUtils";
import { PROJECT_URL } from "../../http";

const POSTPROCESSING_URL = process.env.REACT_APP_POSTPROCESSING_URL || "http://localhost:8010";

function PostProcessing() {
    const [startProcess, setStartProcess] = useState(false);
    const [fetchedFilesData, setFetchedFilesData] = useState([]);
    const [inProgressFiles, setInProgressFiles] = useState([]);
    const [logsData, setLogsData] = useState([]);
    const [processedFiles, setProcessedFiles] = useState([]);
    const [unprocessedFiles, setUnProcessedFiles] = useState([]);
    const [serverStatus, setServerStatus] = useState(false);
    const [serviceUrl, setServiceUrl] = useState("");
    const [serverLoadState, setServerLoadState] = useState(true);
    const [Loader, setLoader] = useState(true);
    const [startIndex, setStartIndex] = useState(undefined);
    const [endIndex, setEndIndex] = useState(undefined);
    const [rowSelection, setRowSelection] = useState({});
    const [fslstartIndex, setfslStartIndex] = useState(undefined);
    const [fslendIndex, setfslEndIndex] = useState(undefined);
    const [fslrowSelection, setfslRowSelection] = useState({});

    const [activeTab, setActiveTab] = useState(0);
    
    // const [postProcessingSettings, setPostProcessingSettings] = useState({
    //     api_key: "",
    //     text_type: "default"
    // });
    
    let [isOpenPopup, setIsOpenPopup] = useState(false);
    let [msg, setMsg] = useState(false);
    let [isSuccess, setIsSuccess] = useState(false);

    const pollingIntervalRef = useRef(null);
    const wasInProgressRef = useRef(false);
    const submittedFileCodesRef = useRef(new Set());

    function closePopup() {
        setIsOpenPopup(false);
    }

    const openPopup = useCallback(() => {
        setIsOpenPopup(true);
    }, []);

    const stopPolling = useCallback(() => {
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
    }, []);


    // const fetchInProgressFiles = useCallback(async () => {
    //     try {
    //         const projectCode = sessionStorage.getItem("projectCode");
    //         if (!projectCode) return;

    //         const response = await axios.get(
    //             `${POSTPROCESSING_URL}/post-processing/in-progress/${projectCode}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //             }
    //         );

    //         if (response.data) {
    //             // Handle both empty and populated responses
    //             const apiData = response.data.data || [];
                
    //             const apiFiles = apiData
    //                 .filter(file => 
    //                     file.status === "Inprogress" || 
    //                     file.status === "submitted" || 
    //                     file.status === "Processing"
    //                 )
    //                 .map(file => ({
    //                     ...file,
    //                     filename: file.filename || file.file_name || file.name
    //                 }));
                
    //             // ✅ Merge with existing state to avoid losing newly submitted files
    //             setInProgressFiles(prevFiles => {
    //                 // If no previous files, just return API files (even if empty)
    //                 if (prevFiles.length === 0) {
    //                     return apiFiles;
    //                 }
                    
    //                 const now = new Date();
    //                 const apiFileCodes = new Set(apiFiles.map(f => f.file_code));
                    
    //                 // Keep recently submitted files that aren't in API yet (< 60 seconds old)
    //                 const recentLocalFiles = prevFiles.filter(f => {
    //                     // Don't duplicate files already in API
    //                     if (apiFileCodes.has(f.file_code)) return false;
                        
    //                     // Keep files submitted less than 60 seconds ago
    //                     const submittedTime = new Date(f.response?.submitted_at || f.creation_date);
    //                     const ageInSeconds = (now - submittedTime) / 1000;
    //                     return ageInSeconds < 60;
    //                 });
                    
    //                 // Combine API files with recent local files
    //                 const mergedFiles = [...apiFiles, ...recentLocalFiles];
                    
    //                 // If no files left, stop polling after a delay
    //                 if (mergedFiles.length === 0 && prevFiles.length > 0) {
    //                     setTimeout(() => {
    //                         setInProgressFiles(current => {
    //                             if (current.length === 0) {
    //                                 stopPolling();
    //                                 setActiveTab(3);
    //                             }
    //                             return current;
    //                         });
    //                     }, 10000); // 10 second grace period
    //                 }
                    
    //                 return mergedFiles;
    //             });
    //         }
    //     } catch (error) {
    //         console.log("Error fetching in-progress files:", error.message);
    //         // Don't clear state on error
    //     }
    // }, [stopPolling]);

    // const fetchInProgressFiles = useCallback(async () => {
    //     try {
    //         const projectCode = sessionStorage.getItem("projectCode");
    //         if (!projectCode) return;

    //         const response = await axios.get(
    //             `${POSTPROCESSING_URL}/post-processing/in-progress/${projectCode}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //             }
    //         );

    //         if (response.data) {
    //             // Handle both empty and populated responses
    //             const apiData = response.data.data || [];
                
    //             const apiFiles = apiData
    //                 .filter(file => 
    //                     file.status === "Inprogress" || 
    //                     file.status === "submitted" || 
    //                     file.status === "Processing"
    //                 )
    //                 .map(file => ({
    //                     ...file,
    //                     filename: file.filename || file.file_name || file.name
    //                 }));
                
    //             // ✅ Merge with existing state to avoid losing newly submitted files
    //             setInProgressFiles(prevFiles => {
    //                 // If no previous files, just return API files (even if empty)
    //                 if (prevFiles.length === 0) {
    //                     // ✅ Mark that we've seen in-progress files if API returned some
    //                     if (apiFiles.length > 0) {
    //                         wasInProgressRef.current = true;
    //                     }
    //                     return apiFiles;
    //                 }
                    
    //                 const now = new Date();
    //                 const apiFileCodes = new Set(apiFiles.map(f => f.file_code));
                    
    //                 // Keep recently submitted files that aren't in API yet (< 60 seconds old)
    //                 const recentLocalFiles = prevFiles.filter(f => {
    //                     // Don't duplicate files already in API
    //                     if (apiFileCodes.has(f.file_code)) return false;
                        
    //                     // Keep files submitted less than 60 seconds ago
    //                     const submittedTime = new Date(f.response?.submitted_at || f.creation_date);
    //                     const ageInSeconds = (now - submittedTime) / 1000;
    //                     return ageInSeconds < 60;
    //                 });
                    
    //                 // Combine API files with recent local files
    //                 const mergedFiles = [...apiFiles, ...recentLocalFiles];

    //                 // ✅ Mark that we've seen in-progress files at some point
    //                 if (mergedFiles.length > 0) {
    //                     wasInProgressRef.current = true;
    //                 }
                    
    //                 // ✅ Only switch to tab 4 if we previously confirmed files were in-progress
    //                 //    This prevents the tab switching prematurely on initial empty state
    //                 if (mergedFiles.length === 0 && prevFiles.length > 0 && wasInProgressRef.current) {
    //                     setTimeout(() => {
    //                         setInProgressFiles(current => {
    //                             if (current.length === 0) {
    //                                 stopPolling();
    //                                 wasInProgressRef.current = false; // ✅ Reset for next run
    //                                 setActiveTab(3);
    //                             }
    //                             return current;
    //                         });
    //                     }, 10000); // 10 second grace period
    //                 }
                    
    //                 return mergedFiles;
    //             });
    //         }
    //     } catch (error) {
    //         console.log("Error fetching in-progress files:", error.message);
    //         // Don't clear state on error
    //     }
    // }, [stopPolling]);

    const fetchInProgressFiles = useCallback(async () => {
        try {
            const projectCode = sessionStorage.getItem("projectCode");
            if (!projectCode) return;

            const response = await axios.get(
                `${POSTPROCESSING_URL}/post-processing/in-progress/${projectCode}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                }
            );

            // if (response.data) {
            //     const apiData = response.data.data || [];

            //     // ✅ FIX: Separate active files from terminal files
            //     const ACTIVE_STATUSES = ["Inprogress", "submitted", "Processing"];
            //     // const TERMINAL_STATUSES = ["success", "Success", "error", "Error", "fail", "Fail", "failed", "Failed"];

            //     const activeApiFiles = apiData
            //         .filter(file => ACTIVE_STATUSES.includes(file.status))
            //         .map(file => ({
            //             ...file,
            //             filename: file.filename || file.file_name || file.name
            //         }));

            //     // const terminalApiFiles = apiData
            //     //     .filter(file => TERMINAL_STATUSES.includes(file.status))
            //     //     .map(file => ({
            //     //         ...file,
            //     //         filename: file.filename || file.file_name || file.name
            //     //     }));

            //     // setInProgressFiles(prevFiles => {
            //     //     const activeApiFileCodes = new Set(activeApiFiles.map(f => f.file_code));
            //     //     const terminalApiFileCodes = new Set(terminalApiFiles.map(f => f.file_code));

            //     //     // Keep local files not yet seen by API at all, within 5 min window
            //     //     const now = new Date();
            //     //     const localOnlyFiles = prevFiles.filter(f => {
            //     //         if (activeApiFileCodes.has(f.file_code)) return false;  // API has it active, don't duplicate
            //     //         if (terminalApiFileCodes.has(f.file_code)) return false; // API says done, remove
            //     //         const submittedTime = new Date(f.response?.submitted_at || f.creation_date);
            //     //         const ageInSeconds = (now - submittedTime) / 1000;
            //     //         return ageInSeconds < 300; // 5 minute grace window
            //     //     });
            //     setInProgressFiles(prevFiles => {
            //         const activeApiFileCodes = new Set(activeApiFiles.map(f => f.file_code));

            //         // Keep local files only if the API still shows them as active
            //         // OR if they were just submitted (within 30s) and API hasn't picked them up yet
            //         const now = new Date();
            //         const localOnlyFiles = prevFiles.filter(f => {
            //             if (activeApiFileCodes.has(f.file_code)) return false; // already in activeApiFiles, no duplicate
            //             // Only keep locally if recently submitted — gives API time to pick it up
            //             const submittedTime = new Date(f.response?.submitted_at || f.creation_date);
            //             const ageInSeconds = (now - submittedTime) / 1000;
            //             return ageInSeconds < 30; // 30s window for API to pick up newly submitted files
            //         });

            //         const mergedFiles = [...activeApiFiles, ...localOnlyFiles];

            //         if (mergedFiles.length > 0 || submittedFileCodesRef.current.size > 0) {
            //             wasInProgressRef.current = true;
            //         }

            //         // Switch to tab 4 when: we had submitted files, and the merged list is now empty
            //         // The API returning [] means all files completed (backend filters out completed files)
            //         if (
            //             wasInProgressRef.current &&
            //             submittedFileCodesRef.current.size > 0 &&
            //             mergedFiles.length === 0 &&
            //             prevFiles.length > 0
            //         ) {
            //             setTimeout(() => {
            //                 setInProgressFiles(current => {
            //                     if (current.length === 0) {
            //                         stopPolling();
            //                         wasInProgressRef.current = false;
            //                         submittedFileCodesRef.current = new Set();
            //                         setActiveTab(3);
            //                     }
            //                     return current;
            //                 });
            //             }, 2000); // 5s grace period
            //         }

            //         return mergedFiles;
            //     });
            // }
            if (response.data) {
                const apiData = response.data.data || [];

                const ACTIVE_STATUSES = ["Inprogress", "submitted", "Processing"];

                const activeApiFiles = apiData
                    .filter(file => ACTIVE_STATUSES.includes(file.status))
                    .map(file => ({
                        ...file,
                        filename: file.filename || file.file_name || file.name
                    }));

                setInProgressFiles(prevFiles => {
                    const activeApiFileCodes = new Set(activeApiFiles.map(f => f.file_code));

                    const now = new Date();
                    const localOnlyFiles = prevFiles.filter(f => {
                        if (activeApiFileCodes.has(f.file_code)) return false;
                        const submittedTime = new Date(f.response?.submitted_at || f.creation_date);
                        const ageInSeconds = (now - submittedTime) / 1000;
                        return ageInSeconds < 30;
                    });

                    const mergedFiles = [...activeApiFiles, ...localOnlyFiles];

                    if (mergedFiles.length > 0 || submittedFileCodesRef.current.size > 0) {
                        wasInProgressRef.current = true;
                    }

                    // ✅ FIX: Detect which submitted files have now disappeared (completed)
                    if (wasInProgressRef.current && submittedFileCodesRef.current.size > 0) {
                        const completedFileCodes = [...submittedFileCodesRef.current].filter(
                            code => !activeApiFileCodes.has(code)
                        );

                        if (completedFileCodes.length > 0) {
                            // Find the original submitted file objects from prevFiles
                            const completedFiles = prevFiles.filter(f =>
                                completedFileCodes.includes(f.file_code)
                            );

                            // Mark them as success (backend dropped them = completed)
                            const succeededFiles = completedFiles.map(f => ({ ...f, status: "success" }));

                            setProcessedFiles(prev => {
                                const existingCodes = new Set(prev.map(f => f.file_code));
                                const newOnes = succeededFiles.filter(f => !existingCodes.has(f.file_code));
                                return [...prev, ...newOnes];
                            });

                            // Update logs for completed files
                            setLogsData(prev => {
                                const updated = [...prev];
                                succeededFiles.forEach(file => {
                                    const name = file.name || file.file_name || file.filename;
                                    const idx = updated.findIndex(l => l.filename === name);
                                    const logEntry = {
                                        filename: name,
                                        status: "success",
                                        status_code: "0",
                                        status_message: "Post-processing completed successfully",
                                        transcribed_detected_lang: null,
                                        api_version: null,
                                        confidence_score: null,
                                        creation_date: new Date(),
                                    };
                                    if (idx >= 0) {
                                        updated[idx] = { ...updated[idx], ...logEntry };
                                    } else {
                                        updated.push(logEntry);
                                    }
                                });
                                return updated;
                            });

                            // Remove completed codes from tracking
                            completedFileCodes.forEach(code => submittedFileCodesRef.current.delete(code));
                        }
                    }

                    // Auto-switch to All Files Status tab when all done
                    if (
                        wasInProgressRef.current &&
                        submittedFileCodesRef.current.size === 0 &&
                        mergedFiles.length === 0 &&
                        prevFiles.length > 0
                    ) {
                        setTimeout(() => {
                            setInProgressFiles(current => {
                                if (current.length === 0) {
                                    stopPolling();
                                    wasInProgressRef.current = false;
                                    setActiveTab(3);
                                }
                                return current;
                            });
                        }, 2000);
                    }

                    return mergedFiles;
                });
            }
        } catch (error) {
            console.log("Error fetching in-progress files:", error.message);
        }
    }, [stopPolling]);

    // const fetchAllFiles = useCallback(async (batch_no = null) => {
    //     try {
    //         setLoader(true);
    //         const projectCode = sessionStorage.getItem("projectCode");
            
    //         const response = await axios.get(
    //             `${POSTPROCESSING_URL}/post-processing/getfilelist/${projectCode}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //                 params: {
    //                     batch: batch_no || sessionStorage.getItem("batch") || null,
    //                 },
    //             }
    //         );

    //         const statusResponse = await axios.get(
    //             `${POSTPROCESSING_URL}/post-processing/filewisestatusrpt/${projectCode}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //             }
    //         );

    //         if (response.data && response.data.data) {
    //             const allFiles = response.data.data;
    //             const completedFileCodes = statusResponse.data.data.filter(f => f.status === "Success" || f.status === "success").map(f => f.file_code);

    //             const availableFiles = allFiles.filter(file => {
    //                 const fileName = file.file_name || file.name || "";
    //                 const isAllowedFile = fileName.endsWith('.txt') || fileName.endsWith('.json');
    //                 const isProcessing = file.status === "Inprogress" || file.status === "submitted" || file.status === "Processing" || file.status === "Success" || file.status === "success";
    //                 const isCompleted = completedFileCodes.includes(file.file_code);
                    
    //                 return isAllowedFile && !isProcessing && !isCompleted;
    //             });
                
    //             setFetchedFilesData(availableFiles);
    //         }
    //     } catch (error) {
    //         const errorMessage = handleApiError(error);
    //         setMsg(errorMessage);
    //         setIsSuccess(false);
    //         openPopup();
    //     } finally {
    //         setTimeout(() => setLoader(false), 100);
    //     }
    // }, [openPopup]);

    // const fetchAllFiles = useCallback(async (batch_no = null) => {
    //     try {
    //         setLoader(true);
    //         const projectCode = sessionStorage.getItem("projectCode");
            
    //         const response = await axios.get(
    //             `${POSTPROCESSING_URL}/post-processing/getfilelist/${projectCode}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //                 params: {
    //                     batch: batch_no || sessionStorage.getItem("batch") || null,
    //                 },
    //             }
    //         );
    //         // Fetch status report
    //         const statusResponse = await axios.get(
    //             `${POSTPROCESSING_URL}/post-processing/filewisestatusrpt/${projectCode}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //             }
    //         );

    //         if (response.data && response.data.data) {
    //             const allFiles = response.data.data;

    //             const statusMap = {};
    //             if (statusResponse.data && statusResponse.data.data) {
    //                 statusResponse.data.data.forEach(statusFile => {
    //                     statusMap[statusFile.file_code] = statusFile.status;
    //                 });
    //             }

    //             // ✅ More comprehensive filtering - exclude all processing/completed files
    //             // const availableFiles = allFiles.filter(file => {
    //             //     const fileName = file.file_name || file.name || "";
    //             //     const fileStatus = (file.status || "").toLowerCase();
                    
    //             //     // Only include .txt and .json files
    //             //     const isAllowedFile = fileName.endsWith('.txt') || fileName.endsWith('.json');
                    
    //             //     // Exclude files that are being processed or completed
    //             //     const excludedStatuses = [
    //             //         'inprogress', 
    //             //         'submitted', 
    //             //         'processing', 
    //             //         'success', 
    //             //         'completed',
    //             //         'failed'
    //             //     ];
    //             //     const isExcluded = excludedStatuses.includes(fileStatus);
                    
    //             //     return isAllowedFile && !isExcluded;
    //             // });
    //             // Filter only txt/json files and merge status
    //             const filesWithStatus = allFiles
    //                 .filter(file => {
    //                     const fileName = file.file_name || file.name || "";
    //                     return fileName.endsWith('.txt') || fileName.endsWith('.json');
    //                 })
    //                 .map(file => ({
    //                     ...file,
    //                     status: statusMap[file.file_code] || file.status || "Unprocessed"
    //                 }));
                
    //             setFetchedFilesData(filesWithStatus);

    //             // setFetchedFilesData(availableFiles);
    //         }
    //     } catch (error) {
    //         const errorMessage = handleApiError(error);
    //         setMsg(errorMessage);
    //         setIsSuccess(false);
    //         openPopup();
    //     } finally {
    //         setTimeout(() => setLoader(false), 100);
    //     }
    // }, [openPopup]);

    const fetchAllFiles = useCallback(async (batch_no = null) => {
        try {
            setLoader(true);
            const projectCode = sessionStorage.getItem("projectCode");
            
            const response = await axios.get(
                `${POSTPROCESSING_URL}/post-processing/getfilelist/${projectCode}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                    params: {
                        batch: batch_no || sessionStorage.getItem("batch") || null,
                    },
                }
            );

            // Fetch status report to get latest status
            const statusResponse = await axios.get(
                `${POSTPROCESSING_URL}/post-processing/filewisestatusrpt/${projectCode}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                }
            );

            if (response.data && response.data.data) {
                const allFiles = response.data.data;

                // Create status map from status report
                const statusMap = {};
                if (statusResponse.data && statusResponse.data.data) {
                    statusResponse.data.data.forEach(statusFile => {
                        statusMap[statusFile.file_code] = statusFile.status;
                    });
                }

                // Show ALL txt/json files with their latest status
                const filesWithStatus = allFiles
                    .filter(file => {
                        const fileName = file.file_name || file.name || "";
                        return fileName.endsWith('.txt') || fileName.endsWith('.json');
                    })
                    .map(file => ({
                        ...file,
                        name: file.file_name || file.name,
                        status: statusMap[file.file_code] || file.status || "Unprocessed"
                    }));
                
                setFetchedFilesData(filesWithStatus);
            }
        } catch (error) {
            const errorMessage = handleApiError(error);
            setMsg(errorMessage);
            setIsSuccess(false);
            openPopup();
        } finally {
            setTimeout(() => setLoader(false), 100);
        }
    }, [openPopup]);

    const startPolling = useCallback(() => {
        if (pollingIntervalRef.current) return;

        pollingIntervalRef.current = setInterval(() => {
            fetchInProgressFiles();
        }, 5000);
    }, [fetchInProgressFiles]);

    // ✅ FIXED: Properly format submitted files with all required fields
    // const handleStartProcess = async (data) => {
    //     setStartProcess(true);
    //     const currentLogs = [];
    //     const updatedProcessedFiles = [];
    //     const updatedUnprocessedFiles = [];

    //     const formattedStartDateTime = () => {
    //         const date = new Date();
    //         const formattedDateString = date
    //             .toLocaleString("en-US", {
    //                 day: "2-digit",
    //                 month: "2-digit",
    //                 year: "numeric",
    //                 hour: "2-digit",
    //                 minute: "2-digit",
    //                 second: "2-digit",
    //                 hour12: false,
    //             })
    //             .replace(/\//g, "/")
    //             .replace(",", " ");
    //         const [month, day, yearAndTime] = formattedDateString.split("/");
    //         return `${day}-${month}-${yearAndTime}`;
    //     };

    //     for (let i = 0; i < data.length; i++) {
    //         let startdt = formattedStartDateTime();
    //         let file = data[i];
            
    //         try {
    //             if (!file.file_code) {
    //                 throw new Error("File code is missing");
    //             }

    //             // const payload = {
    //             //     payload: {
    //             //         project_code: sessionStorage.getItem("projectCode"),
    //             //         file_code: file.file_code,
    //             //         api_key: postProcessingSettings.api_key,
    //             //         text_type: postProcessingSettings.text_type
    //             //     }
    //             // };
    //             // ✅ FIXED: Remove the "payload" wrapper and use correct field name
    //             const payload = {
    //                 project_code: sessionStorage.getItem("projectCode"),
    //                 file_code: file.file_code,
    //                 openai_api_key: postProcessingSettings.api_key,  // ✅ Changed from "api_key"
    //                 text_type: postProcessingSettings.text_type
    //             };

    //             const response = await axios.post(
    //                 `${POSTPROCESSING_URL}/post-processing/`,
    //                 payload,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                         "Content-Type": "application/json"
    //                     },
    //                 }
    //             );

    //             if (response.data.status === "submitted") {
    //                 const now = new Date();
    //                 const submittedFile = {
    //                     ...file,
    //                     file_code: file.file_code,
    //                     filename: file.name || file.file_name,  // ✅ Explicit filename
    //                     name: file.name || file.file_name,
    //                     file_name: file.file_name || file.name,
    //                     status: "submitted",
    //                     response: {
    //                         message: response.data.message,
    //                         submitted_at: now.toISOString()
    //                     },
    //                     start_date_time: startdt,
    //                     creation_date: now,
    //                     last_modified: "",
    //                     text_type: postProcessingSettings.text_type
    //                 };
                    
    //                 currentLogs.push({
    //                     creation_date: now,
    //                     filename: file.name || file.file_name,
    //                     status: "submitted",
    //                     message: response.data.message
    //                 });
                    
    //                 updatedProcessedFiles.push(submittedFile);
                    
    //                 // ✅ Add to in-progress immediately
    //                 setInProgressFiles(prev => [...prev, submittedFile]);
    //             } else {
    //                 console.error('Unexpected response status:', response.data.status);
    //                 const errordate = new Date();
    //                 currentLogs.push({
    //                     creation_date: errordate,
    //                     filename: file.name || file.file_name,
    //                     status: "error"
    //                 });
    //                 updatedUnprocessedFiles.push(file);
    //             }
    //         } catch (error) {
    //             console.error('Post-Processing Error:', error);
                
    //             const errordate = new Date();
    //             let errorMessage = error.response?.data?.detail || 
    //                             error.response?.data?.message || 
    //                             error.message ||
    //                             "An error occurred during post-processing";
                
    //             currentLogs.push({
    //                 filename: file.name || file.file_name,
    //                 creation_date: errordate,
    //                 error: errorMessage
    //             });
                
    //             setMsg(errorMessage);
    //             setIsSuccess(false);
    //             if (data.length === 1) {
    //                 openPopup();
    //             }
                
    //             updatedUnprocessedFiles.push(file);
    //         }
    //     }

    //     setLogsData(currentLogs);
    //     setProcessedFiles(updatedProcessedFiles);
    //     setUnProcessedFiles(updatedUnprocessedFiles);
    //     setStartProcess(false);
        
    //     await fetchAllFiles();
        
    //     // ✅ Start polling after submission
    //     if (updatedProcessedFiles.length > 0) {
    //         startPolling();
    //     }
    // };

    // Add this function to get active POST_PROCESSING params
    const getActivePostProcessingParams = async () => {
        try {
            const response = await axios.get(
                `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    }
                }
            );
            
            // Find active POST_PROCESSING param
            const activeParam = response.data.data.find(
                param => (param.process_code === 'POST_PROCESSING' || param.process_code === 'PostProcessing') 
                        && param.status === true
            );
            
            if (activeParam && activeParam.params) {
                return activeParam.params.text_type || 'default';
            }
            
            // return 'default';
            return null;
        } catch (error) {
            console.error("Error fetching params:", error);
            // return 'default';
            return null;
        }
    };

    // const handleStartProcess = async (data) => {
    //     setStartProcess(true);
    //     setActiveTab(1);
 
    //     // ✅ Immediately remove selected files from the Files tab
    //     const selectedFileCodes = data.map(f => f.file_code);
    //     setFetchedFilesData(prev => prev.filter(f => !selectedFileCodes.includes(f.file_code)));
    //     setRowSelection({}); // Clear selection

    //     let apiKey = null;
    //     let params = {};
        
    //     try {
    //         const projectResponse = await axios.post(
    //             `${PROJECT_URL}/projects/list`,
    //             {
    //                 userInfo: {
    //                     _id: sessionStorage.getItem("userid"),
    //                     clientId: sessionStorage.getItem('client'),
    //                     role: sessionStorage.getItem('role')
    //                 },
    //                 payload: {}
    //             },
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 }
    //             }
    //         );
            
    //         const currentProject = projectResponse.data.find(
    //             p => p.project_code === sessionStorage.getItem("projectCode")
    //         );
            
    //         if (currentProject) {
    //             if (currentProject.azure_enabled && currentProject.azure_param) {
    //                 apiKey = currentProject.gpt_key;
    //                 params = {
    //                     service: 'azure',
    //                     azure_key: currentProject.azure_param.azure_key,
    //                     azure_endpoint: currentProject.azure_param.azure_endpoint
    //                 };
    //             } else {
    //                 apiKey = currentProject.gpt_key;
    //                 params = { service: 'openai' };
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Failed to fetch project:", error);
    //     }

    //     const modelProvider = params.service || "openai";

    //     if (!apiKey || apiKey.trim() === "") {
    //         apiKey = sessionStorage.getItem("api_key") || localStorage.getItem("api_key");
    //     }

    //     if (!apiKey || apiKey.trim() === "") {
    //         setMsg("API key not configured. Please add an API key in Project Setup.");
    //         setIsSuccess(false);
    //         openPopup();
    //         setStartProcess(false);
    //         return;
    //     }

    //     const currentLogs = [];
    //     const updatedProcessedFiles = [];
    //     const updatedUnprocessedFiles = [];

    //     const formattedStartDateTime = () => {
    //         const date = new Date();
    //         const formattedDateString = date
    //             .toLocaleString("en-US", {
    //                 day: "2-digit",
    //                 month: "2-digit",
    //                 year: "numeric",
    //                 hour: "2-digit",
    //                 minute: "2-digit",
    //                 second: "2-digit",
    //                 hour12: false,
    //             })
    //             .replace(/\//g, "/")
    //             .replace(",", " ");
    //         const [month, day, yearAndTime] = formattedDateString.split("/");
    //         return `${day}-${month}-${yearAndTime}`;
    //     };

    //     for (let i = 0; i < data.length; i++) {
    //         let startdt = formattedStartDateTime();
    //         let file = data[i];
            
    //         try {
    //             if (!file.file_code) {
    //                 throw new Error("File code is missing");
    //             }

    //             const payload = {
    //                 project_code: sessionStorage.getItem("projectCode"),
    //                 file_code: file.file_code,
    //                 openai_api_key: apiKey,
    //                 text_type: "default"
    //             };

    //             const response = await axios.post(
    //                 `${POSTPROCESSING_URL}/post-processing/`,
    //                 payload,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                         "Content-Type": "application/json"
    //                     },
    //                 }
    //             );

    //             if (response.data.status === "submitted") {
    //                 const now = new Date();
    //                 const submittedFile = {
    //                     ...file,
    //                     file_code: file.file_code,
    //                     filename: file.name || file.file_name,
    //                     name: file.name || file.file_name,
    //                     file_name: file.file_name || file.name,
    //                     status: "submitted",
    //                     response: {
    //                         message: response.data.message,
    //                         submitted_at: now.toISOString()
    //                     },
    //                     start_date_time: startdt,
    //                     creation_date: now,
    //                     last_modified: "",
    //                     text_type: "default"
    //                 };
                    
    //                 currentLogs.push({
    //                     creation_date: now,
    //                     filename: file.name || file.file_name,
    //                     status: "submitted",
    //                     message: response.data.message
    //                 });
                    
    //                 updatedProcessedFiles.push(submittedFile);
    //                 setInProgressFiles(prev => [...prev, submittedFile]);
    //             } else {
    //                 console.error('Unexpected response status:', response.data.status);
    //                 const errordate = new Date();
    //                 currentLogs.push({
    //                     creation_date: errordate,
    //                     filename: file.name || file.file_name,
    //                     status: "error"
    //                 });
    //                 updatedUnprocessedFiles.push(file);
    //             }
    //         } catch (error) {
    //             console.error('Post-Processing Error:', error);
                
    //             const errordate = new Date();
    //             let errorMessage = error.response?.data?.detail || 
    //                             error.response?.data?.message || 
    //                             error.message ||
    //                             "An error occurred during post-processing";
                
    //             currentLogs.push({
    //                 filename: file.name || file.file_name,
    //                 creation_date: errordate,
    //                 error: errorMessage
    //             });
                
    //             setMsg(errorMessage);
    //             setIsSuccess(false);
    //             if (data.length === 1) {
    //                 openPopup();
    //             }
                
    //             updatedUnprocessedFiles.push(file);
    //         }
    //     }

    //     setLogsData(currentLogs);
    //     setProcessedFiles(updatedProcessedFiles);
    //     setUnProcessedFiles(updatedUnprocessedFiles);
    //     setStartProcess(false);
        
    //     await fetchAllFiles();
        
    //     if (updatedProcessedFiles.length > 0) {
    //         startPolling();
    //         // setActiveTab(3);
    //     }
    // };

    // const handleStartProcess = async (data) => {
    //     setStartProcess(true);
    //     setActiveTab(1);

    //     // ✅ Get active text_type from params
    //     const textType = await getActivePostProcessingParams();
    //     console.log("Active text_type:", textType);

    //     // ✅ Check if params are configured
    //     if (!textType) {
    //         setMsg("No active parameters configured for post-processing. Please configure parameters in Project Setup.");
    //         setIsSuccess(false);
    //         openPopup();
    //         setStartProcess(false);
    //         return;
    //     }

    //     // ✅ Validate files based on text_type
    //     const invalidFiles = data.filter(file => {
    //         const fileName = (file.name || file.file_name || "").toLowerCase();
            
    //         if (textType === 'transcribed') {
    //             return !fileName.endsWith('.txt');
    //         } else if (textType === 'diarized') {
    //             return !fileName.endsWith('.json');
    //         }
    //         // default allows both txt and json
    //         return false;
    //     });

    //     if (invalidFiles.length > 0) {
    //         let fileTypeRequired;
    //         if (textType === 'transcribed') {
    //             fileTypeRequired = 'TXT (transcribed)';
    //         } else if (textType === 'diarized') {
    //             fileTypeRequired = 'JSON (diarized)';
    //         } else {
    //             fileTypeRequired = 'TXT or JSON';
    //         }
            
    //         const invalidFileNames = invalidFiles.map(f => {
    //             const name = f.name || f.file_name;
    //             const ext = name.split('.').pop().toUpperCase();
    //             return `${name} (${ext})`;
    //         }).join('\n• ');
            
    //         const message = `Current parameter configuration requires ${fileTypeRequired} files only.\n\nThe following ${invalidFiles.length} file(s) cannot be processed:\n• ${invalidFileNames}\n\nPlease either:\n1. Select only ${fileTypeRequired} files, or\n2. Change the Text Type parameter in Project Setup → Parameters`;
            
    //         setMsg(message);
    //         setIsSuccess(false);
    //         openPopup();
    //         setStartProcess(false);
    //         return;
    //     }

    //     // ✅ Immediately remove selected files from the Files tab
    //     const selectedFileCodes = data.map(f => f.file_code);
    //     setFetchedFilesData(prev => prev.filter(f => !selectedFileCodes.includes(f.file_code)));
    //     setRowSelection({});

    //     let apiKey = null;
    //     let params = {};
        
    //     try {
    //         const projectResponse = await axios.post(
    //             `${PROJECT_URL}/projects/list`,
    //             {
    //                 userInfo: {
    //                     _id: sessionStorage.getItem("userid"),
    //                     clientId: sessionStorage.getItem('client'),
    //                     role: sessionStorage.getItem('role')
    //                 },
    //                 payload: {}
    //             },
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 }
    //             }
    //         );
            
    //         const currentProject = projectResponse.data.find(
    //             p => p.project_code === sessionStorage.getItem("projectCode")
    //         );
            
    //         if (currentProject) {
    //             if (currentProject.azure_enabled && currentProject.azure_param) {
    //                 apiKey = currentProject.gpt_key;
    //                 params = {
    //                     service: 'azure',
    //                     azure_key: currentProject.azure_param.azure_key,
    //                     azure_endpoint: currentProject.azure_param.azure_endpoint
    //                 };
    //             } else {
    //                 apiKey = currentProject.gpt_key;
    //                 params = { service: 'openai' };
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Failed to fetch project:", error);
    //     }

    //     const modelProvider = params.service || "openai";

    //     if (!apiKey || apiKey.trim() === "") {
    //         apiKey = sessionStorage.getItem("api_key") || localStorage.getItem("api_key");
    //     }

    //     // if (!apiKey || apiKey.trim() === "") {
    //     //     setMsg("API key not configured. Please add an API key in Project Setup.");
    //     //     setIsSuccess(false);
    //     //     openPopup();
    //     //     setStartProcess(false);
    //     //     return;
    //     // }

    //     const currentLogs = [];
    //     const updatedProcessedFiles = [];
    //     const updatedUnprocessedFiles = [];

    //     const formattedStartDateTime = () => {
    //         const date = new Date();
    //         const formattedDateString = date
    //             .toLocaleString("en-US", {
    //                 day: "2-digit",
    //                 month: "2-digit",
    //                 year: "numeric",
    //                 hour: "2-digit",
    //                 minute: "2-digit",
    //                 second: "2-digit",
    //                 hour12: false,
    //             })
    //             .replace(/\//g, "/")
    //             .replace(",", " ");
    //         const [month, day, yearAndTime] = formattedDateString.split("/");
    //         return `${day}-${month}-${yearAndTime}`;
    //     };

    //     for (let i = 0; i < data.length; i++) {
    //         let startdt = formattedStartDateTime();
    //         let file = data[i];
            
    //         try {
    //             if (!file.file_code) {
    //                 throw new Error("File code is missing");
    //             }

    //             // // Fetch project configuration
    //             // const projectConfig = await fetch(`/api/projects/${sessionStorage.getItem("projectCode")}`).then(r => r.json());

    //             // // Determine provider and credentials
    //             // // const apiProvider = projectConfig.azure_key ? "azure" : "openai";
    //             // // const apiKey = apiProvider === "azure" ? projectConfig.azure_key : projectConfig.gpt_key;
    //             // // Determine provider
    //             // const isAzure = projectConfig.azure_key && projectConfig.azure_endpoint;

    //             // const payload = {
    //             //     project_code: sessionStorage.getItem("projectCode"),
    //             //     file_code: file.file_code,
    //             //     // openai_api_key: apiKey,
    //             //     openai_api_key: isAzure ? projectConfig.azure_key : projectConfig.gpt_key,
    //             //     text_type: textType,  // ✅ Send the active text_type (transcribed/diarized/default)
    //             //     // NEW FIELDS:
    //             //     api_provider: isAzure ? "azure" : "openai",
    //             //     azure_endpoint: isAzure ? projectConfig.azure_endpoint : null,
    //             //     azure_deployment_name: isAzure ? projectConfig.azure_deployment_name : null
    //             // };

    //             // Use the project config already fetched earlier in the function
    //             const projectResponse = await axios.post(
    //                 `${PROJECT_URL}/projects/list`,
    //                 {
    //                     userInfo: {
    //                         _id: sessionStorage.getItem("userid"),
    //                         clientId: sessionStorage.getItem('client'),
    //                         role: sessionStorage.getItem('role')
    //                     },
    //                     payload: {}
    //                 },
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                     }
    //                 }
    //             );

    //             const projectConfig = projectResponse.data.find(
    //                 p => p.project_code === sessionStorage.getItem("projectCode")
    //             );

    //             // ✅ CORRECT: Check azure_param.azure_key
    //             // const isAzure = projectConfig.azure_param?.azure_enabled && 
    //             //             projectConfig.azure_param?.azure_key && 
    //             //             projectConfig.azure_param?.azure_endpoint;
    //             const isAzure = Boolean(projectConfig.azure_param?.azure_key);

    //             const payload = {
    //                 project_code: sessionStorage.getItem("projectCode"),
    //                 file_code: file.file_code,
    //                 text_type: textType,
    //                 api_provider: isAzure ? "azure" : "openai",
    //                 ...(isAzure ? {
    //                     // ✅ For Azure, send azure_api_key (backend expects this field)
    //                     azure_api_key: projectConfig.azure_param.azure_key,
    //                     azure_endpoint: projectConfig.azure_param.azure_endpoint,
    //                     azure_deployment_name: projectConfig.azure_param.azure_deployment_name,
    //                     openai_api_key: null
    //                 } : {
    //                     // For OpenAI
    //                     openai_api_key: projectConfig.gpt_key,
    //                     azure_api_key: null,
    //                     azure_endpoint: null,
    //                     azure_deployment_name: null
    //                 })
    //             };

    //             console.log("Is Azure?", isAzure);
    //             console.log("Azure Param:", projectConfig.azure_param);
    //             console.log("Sending payload:", JSON.stringify(payload, null, 2));

    //             const response = await axios.post(
    //                 `${POSTPROCESSING_URL}/post-processing/`,
    //                 payload,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                         "Content-Type": "application/json"
    //                     },
    //                 }
    //             );

    //             if (response.data.status === "submitted") {
    //                 const now = new Date();
    //                 const submittedFile = {
    //                     ...file,
    //                     file_code: file.file_code,
    //                     filename: file.name || file.file_name,
    //                     name: file.name || file.file_name,
    //                     file_name: file.file_name || file.name,
    //                     status: "submitted",
    //                     response: {
    //                         message: response.data.message,
    //                         submitted_at: now.toISOString()
    //                     },
    //                     start_date_time: startdt,
    //                     creation_date: now,
    //                     last_modified: "",
    //                     text_type: textType
    //                 };
                    
    //                 currentLogs.push({
    //                     creation_date: now,
    //                     filename: file.name || file.file_name,
    //                     status: "submitted",
    //                     message: response.data.message
    //                 });
                    
    //                 updatedProcessedFiles.push(submittedFile);
    //                 setInProgressFiles(prev => [...prev, submittedFile]);
    //             } else {
    //                 console.error('Unexpected response status:', response.data.status);
    //                 const errordate = new Date();
    //                 currentLogs.push({
    //                     creation_date: errordate,
    //                     filename: file.name || file.file_name,
    //                     status: "error"
    //                 });
    //                 updatedUnprocessedFiles.push(file);
    //             }
    //         } catch (error) {
    //             console.error('Post-Processing Error:', error);
                
    //             const errordate = new Date();
    //             let errorMessage = error.response?.data?.detail || 
    //                             error.response?.data?.message || 
    //                             error.message ||
    //                             "An error occurred during post-processing";
                
    //             currentLogs.push({
    //                 filename: file.name || file.file_name,
    //                 creation_date: errordate,
    //                 error: errorMessage
    //             });
                
    //             setMsg(errorMessage);
    //             setIsSuccess(false);
    //             if (data.length === 1) {
    //                 openPopup();
    //             }
                
    //             updatedUnprocessedFiles.push(file);
    //         }
    //     }

    //     setLogsData(currentLogs);
    //     setProcessedFiles(updatedProcessedFiles);
    //     setUnProcessedFiles(updatedUnprocessedFiles);
    //     setStartProcess(false);
        
    //     await fetchAllFiles();
        
    //     if (updatedProcessedFiles.length > 0) {
    //         startPolling();
    //     }
    // };

    const handleStartProcess = async (data) => {
        setStartProcess(true);
        setActiveTab(1);

        // 1️⃣ Get active post-processing parameter
        const textType = await getActivePostProcessingParams();
        console.log("Active text_type:", textType);

        if (!textType) {
            setMsg(
                "No active parameters configured for post-processing. Please configure parameters in Project Setup."
            );
            setIsSuccess(false);
            openPopup();
            setStartProcess(false);
            return;
        }

        // 2️⃣ Validate file types
        const invalidFiles = data.filter(file => {
            const fileName = (file.name || file.file_name || "").toLowerCase();

            if (textType === "transcribed") return !fileName.endsWith(".txt");
            if (textType === "diarized") return !fileName.endsWith(".json");
            return false;
        });

        if (invalidFiles.length > 0) {
            const fileTypeRequired =
                textType === "transcribed"
                    ? "TXT (transcribed)"
                    : textType === "diarized"
                    ? "JSON (diarized)"
                    : "TXT or JSON";

            const invalidFileNames = invalidFiles
                .map(f => {
                    const name = f.name || f.file_name;
                    return `${name} (${name.split(".").pop().toUpperCase()})`;
                })
                .join("\n• ");

            setMsg(
                `Current parameter configuration requires ${fileTypeRequired} files only.\n\n` +
                `The following ${invalidFiles.length} file(s) cannot be processed:\n• ${invalidFileNames}\n\n` +
                `Please either:\n1. Select only ${fileTypeRequired} files, or\n` +
                `2. Change the Text Type parameter in Project Setup → Parameters`
            );
            setIsSuccess(false);
            openPopup();
            setStartProcess(false);
            return;
        }

        // 3️⃣ Optimistic UI update
        const selectedFileCodes = data.map(f => f.file_code);
        setFetchedFilesData(prev =>
            prev.filter(f => !selectedFileCodes.includes(f.file_code))
        );
        setRowSelection({});

        // 4️⃣ 🔑 PROJECT CONFIG (NO /projects/list)
        // Assumes project setup already stored these values
        // const projectConfig = {
        //     gpt_key: sessionStorage.getItem("api_key") || localStorage.getItem("api_key"),
        //     azure_param: JSON.parse(sessionStorage.getItem("azure_param") || "null")
        // };

        // 4️⃣ 🔑 PROJECT CONFIG - Fetch from backend
        // let projectConfig;
        // try {
        //     const projectResponse = await axios.get(
        //         `${PROJECT_URL}/projects/${sessionStorage.getItem("projectCode")}`,
        //         {
        //             headers: {
        //                 Authorization: `Bearer ${localStorage.getItem("access_token")}`
        //             }
        //         }
        //     );
        //     projectConfig = projectResponse.data;
        // } catch (error) {
        //     setMsg("Failed to fetch project configuration");
        //     setIsSuccess(false);
        //     openPopup();
        //     setStartProcess(false);
        //     return;
        // }

        // const isAzure = Boolean(projectConfig.azure_param?.azure_key);

        // 4️⃣ 🔑 PROJECT CONFIG - Fetch from backend
        let projectConfig;
        try {
            const projectResponse = await axios.post(
                `${PROJECT_URL}/projects/${sessionStorage.getItem("projectCode")}`,
                {
                    userInfo: {
                        _id: sessionStorage.getItem("userid"),
                        clientId: sessionStorage.getItem('client'),
                        role: sessionStorage.getItem('role')
                    },
                    payload: {}
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`
                    }
                }
            );
            projectConfig = projectResponse.data;
        } catch (error) {
            setMsg("Failed to fetch project configuration");
            setIsSuccess(false);
            openPopup();
            setStartProcess(false);
            return;
        }

        const isAzure = Boolean(projectConfig.azure_param?.azure_key);

        console.log("Project config:", projectConfig);
        console.log("Azure param:", projectConfig.azure_param);
        console.log("Azure key exists:", Boolean(projectConfig.azure_param?.azure_key));
        console.log("All sessionStorage keys:", Object.keys(sessionStorage));
        console.log("All localStorage keys:", Object.keys(localStorage));
        console.log("azure_param raw:", sessionStorage.getItem("azure_param"));
        console.log("api_key raw:", sessionStorage.getItem("api_key"));
        // 5️⃣ Helpers
        const formattedStartDateTime = () => {
            const d = new Date();
            return d
                .toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false
                })
                .replace(",", "");
        };

        const currentLogs = [];
        const updatedProcessedFiles = [];
        const updatedUnprocessedFiles = [];

        // 6️⃣ Process files
        for (const file of data) {
            const startdt = formattedStartDateTime();

            try {
                if (!file.file_code) throw new Error("File code is missing");

                const payload = {
                    project_code: sessionStorage.getItem("projectCode"),
                    file_code: file.file_code,
                    text_type: textType,
                    api_provider: isAzure ? "azure" : "openai",
                    ...(isAzure
                        ? {
                            azure_api_key: projectConfig.azure_param.azure_key,
                            azure_endpoint: projectConfig.azure_param.azure_endpoint,
                            azure_deployment_name:
                                projectConfig.azure_param.azure_deployment_name,
                            openai_api_key: null
                        }
                        : {
                            openai_api_key: projectConfig.gpt_key,
                            azure_api_key: null,
                            azure_endpoint: null,
                            azure_deployment_name: null
                        })
                };

                const response = await axios.post(
                    `${POSTPROCESSING_URL}/post-processing/`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                            "Content-Type": "application/json"
                        }
                    }
                );

                if (response.data.status === "submitted") {
                    const now = new Date();

                    const submittedFile = {
                        ...file,
                        status: "submitted",
                        start_date_time: startdt,
                        creation_date: now,
                        last_modified: "",
                        text_type: textType,
                        response: {
                            message: response.data.message,
                            submitted_at: now.toISOString()
                        }
                    };

                    // currentLogs.push({
                    //     creation_date: now,
                    //     filename: file.name || file.file_name,
                    //     status: "submitted",
                    //     message: response.data.message
                    // });
                    currentLogs.push({
                        filename: file.name || file.file_name,
                        status: "submitted",
                        status_code: null,
                        status_message: response.data.message,
                        transcribed_detected_lang: null,
                        api_version: null,
                        confidence_score: null,
                        creation_date: now,
                    });

                    updatedProcessedFiles.push(submittedFile);
                    setInProgressFiles(prev => [...prev, submittedFile]);
                    submittedFileCodesRef.current.add(file.file_code);
                } else {
                    throw new Error("Unexpected response from post-processing service");
                }
            } catch (error) {
                const errMsg =
                    error.response?.data?.detail ||
                    error.response?.data?.message ||
                    error.message;

                // currentLogs.push({
                //     filename: file.name || file.file_name,
                //     creation_date: new Date(),
                //     error: errMsg
                // });
                currentLogs.push({
                    filename: file.name || file.file_name,
                    status: "error",
                    status_code: "1",
                    status_message: errMsg,
                    transcribed_detected_lang: null,
                    api_version: null,
                    confidence_score: null,
                    creation_date: new Date(),
                });

                updatedUnprocessedFiles.push(file);
                setMsg(errMsg);
                setIsSuccess(false);
                if (data.length === 1) openPopup();
            }
        }

        // 7️⃣ Finalize UI
        setLogsData(currentLogs);
        setProcessedFiles(updatedProcessedFiles);
        setUnProcessedFiles(updatedUnprocessedFiles);
        setStartProcess(false);

        await fetchAllFiles();

        if (updatedProcessedFiles.length > 0) {
            startPolling();
        }
    };

    const ReloadData = useCallback(async () => {
        setRowSelection({});
        setStartIndex(undefined);
        setEndIndex(undefined);
        
        await Promise.all([
            fetchAllFiles(),
            fetchInProgressFiles()
        ]);
    }, [fetchAllFiles, fetchInProgressFiles]);

    const fetchBatchData = async (batch_no) => {
        await fetchAllFiles(batch_no);
    };

    useEffect(() => {
        const initializeData = async () => {
            await Promise.all([
                fetchAllFiles(),
                fetchInProgressFiles(),
            ]);

            try {
                const response = await axios.get(
                    `${POSTPROCESSING_URL}/post-processing/instancemonitor`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                        params: { server_instance: "GPU" },
                    }
                );
                if (response.data) {
                    setServerStatus(response.data.data[0].serverStatus);
                    setServiceUrl(response.data.data[0].service_url);
                }
            } catch (error) {
                setServerStatus(false);
                setServiceUrl("");
            } finally {
                setServerLoadState(false);
            }
        };

        initializeData();

        // Check if there are already files in progress and start polling
        const checkAndStartPolling = async () => {
            const projectCode = sessionStorage.getItem("projectCode");
            if (!projectCode) return;

            try {
                const response = await axios.get(
                    `${POSTPROCESSING_URL}/post-processing/in-progress/${projectCode}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );

                if (response.data && response.data.data && response.data.data.length > 0) {
                    startPolling();
                }
            } catch (error) {
                console.log("No initial polling needed");
            }
        };

        checkAndStartPolling();

        return () => {
            stopPolling();
        };
    }, [fetchAllFiles, fetchInProgressFiles, startPolling, stopPolling]);

    // ✅ Watch for completion and switch to "All Files Status" tab
    // useEffect(() => {
    //     // Check if we just finished processing (had files, now don't)
    //     const hasProcessedFiles = processedFiles.length > 0;
    //     const noInProgressFiles = inProgressFiles.length === 0;
    //     const isProcessComplete = hasProcessedFiles && noInProgressFiles && !startProcess;
        
    //     if (isProcessComplete) {
    //         // All files completed, wait 2 seconds then switch to tab 4
    //         const timer = setTimeout(() => {
    //             console.log("Switching to All Files Status tab");
    //             setActiveTab(3);
    //         }, 2000);
            
    //         return () => clearTimeout(timer);
    //     }
    // }, [inProgressFiles.length, processedFiles.length, startProcess]);

    // Auto-refresh Files tab every 5 seconds when there are in-progress files
    useEffect(() => {
        if (inProgressFiles.length > 0) {
            const interval = setInterval(() => {
                fetchAllFiles();
            }, 5000);
            
            return () => clearInterval(interval);
        }
    }, [inProgressFiles.length, fetchAllFiles]);

    // ✅ Sync processedFiles / unprocessedFiles as inProgressFiles resolve
    // useEffect(() => {
    //     if (inProgressFiles.length === 0) return;

    //     const succeeded = inProgressFiles.filter(f => f.status === "success");
    //     const failed    = inProgressFiles.filter(f => f.status === "error");

    //     if (succeeded.length === 0 && failed.length === 0) return;

    //     setProcessedFiles(succeeded);
    //     setUnProcessedFiles(failed);

    //     setLogsData(prev => {
    //         const updated = [...prev];
    //         [...succeeded, ...failed].forEach(file => {
    //             const existingIdx = updated.findIndex(
    //                 l => l.filename === (file.name || file.file_name)
    //             );
    //             const logEntry = {
    //                 filename: file.name || file.file_name,
    //                 status: file.status,
    //                 status_code: file.status === "success" ? "0" : "1",
    //                 status_message: file.status === "success"
    //                     ? "Post-processing completed successfully"
    //                     : (file.response?.error || "Post-processing failed"),
    //                 transcribed_detected_lang: null,
    //                 api_version: null,
    //                 confidence_score: null,
    //                 creation_date: file.last_modified || new Date(),
    //             };
    //             if (existingIdx >= 0) {
    //                 updated[existingIdx] = { ...updated[existingIdx], ...logEntry };
    //             }
    //         });
    //         return updated;
    //     });
    // }, [inProgressFiles]);

    const tabs = [
        {
            id: 1,
            title: "Files",
            content: (
                <PostProcessingFilesToProcess
                    serverStatus={serverStatus}
                    ReloadData={ReloadData}
                    items={fetchedFilesData}
                    startProcess={startProcess}
                    setFilesData={handleStartProcess}
                    Loader={Loader}
                    startIndex={startIndex}
                    endIndex={endIndex}
                    setStartIndex={setStartIndex}
                    setEndIndex={setEndIndex}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    // postProcessingSettings={postProcessingSettings}
                    // setPostProcessingSettings={setPostProcessingSettings}
                />
            ),
        },
        {
            id: 2,
            title: "Post-Processing Process",
            content: (
                <PostProcessingProcess
                    startProcess={startProcess}
                    selectedFilesToProcess={inProgressFiles}
                />
            ),
        },
        {
            id: 3,
            title: "Logs",
            content: (
                // <PostProcessingProcessLogs
                //     logs={logsData}
                //     processedfiles={processedFiles}
                //     unprocessedfiles={unprocessedFiles}
                // />
                <PostProcessingProcessLogs
                    logs={logsData}
                    processedfiles={processedFiles}
                    // unprocessedfiles={fetchedFilesData}
                    unprocessedfiles={fetchedFilesData.filter(f => 
                        (f.status || "").toLowerCase() === "uploaded"
                    )}
                />
            ),
        },
        {
            id: 4,
            title: "All Files Status",
            content: (
                <PostProcessingFilewiseStatusLogs 
                    startIndex={fslstartIndex}
                    endIndex={fslendIndex}
                    setStartIndex={setfslStartIndex}
                    setEndIndex={setfslEndIndex}
                    rowSelection={fslrowSelection}
                    setRowSelection={setfslRowSelection}
                />
            ),
        },
    ];

    return (
        <>
            <Popup
                isOpen={isOpenPopup}
                msg={msg}
                closeModal={closePopup}
                isSuccess={isSuccess}
            />
            <ProcessLayout
                startProcess={startProcess}
                tabs={tabs}
                server="Post-Processing Service"
                serverStatus={serverStatus}
                serviceUrl={serviceUrl}
                serverLoadState={serverLoadState}
                batching={true}
                handleBatchChange={fetchBatchData}
                activeTab={activeTab}           // ✅ Add this
                setActiveTab={setActiveTab}
            />
        </>
    );
}

export default PostProcessing;